exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".component-fade-enter-active,.component-fade-leave-active{-webkit-transition:opacity .3s ease;transition:opacity .3s ease}.component-fade-enter,.component-fade-leave-to{opacity:0}", ""]);

// exports
